import { createStore } from "vuex";
import search from "./storeModules/search"
import user from "./storeModules/user"
import task from "./storeModules/task"
import job from "./storeModules/job"
// import landingpage from "./storeModules/landingpage"
export default createStore({
  modules: {
    search,
    user,
    task,
    job,
    // landingpage,
  }
});
